/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import Guard from './services/middleware';

import Loader from './components/Loader/Loader.vue';

const AppWrapper = () => ({ component: import('./AppWrapper.vue'), loader: Loader });
const Login = () => ({ component: import('./views/Login/Login.vue'), loader: Loader });
const Chat = () => ({ component: import('./views/Chat/Chat.vue'), loader: Loader });
const Stub = () => ({ component: import('./views/Stub/Stub.vue'), loader: Loader });

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      component: Login,
    },
    {
      path: '/logout',
      beforeEnter: (to, from, next) => {
        // console.log('beforeEnter: /logout');
        store.dispatch('sessionView/cleanMessages');
        store.dispatch('user/logout', {});
        next('/login');
      },
    },
    {
      path: '/stub',
      component: Stub,
    },
    {
      path: '/builtinchat',
      beforeEnter: Guard.auth,
      component: AppWrapper,
      children: [
        {
          path: '/',
          component: Chat,
        },
        {
          path: '/:id',
          component: Chat,
        },
        {
          path: '/s',
          component: Chat,
        },
        {
          path: '/s/:id',
          component: Chat,
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  // console.log('beforeEach');
  store.dispatch('loader/setLoaderState', true);
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
  next();
});

router.afterEach((to, from) => {
  store.dispatch('loader/setLoaderState', false);
});

export default router;
